import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { getColor } from './color.helper';

@Pipe({
  name: 'color',
  pure: true
})
@Injectable()
export class colorPipe implements PipeTransform {
  transform(value: string): string {
    return getColor(value);
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pipes/color/color.pipe.ts